module.exports = __webpack_public_path__ + "static/img/logo.e5566fa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/guoguoImg/logo.png
// module id = UcEz
// module chunks = 1